import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { styled } from 'styled-components';
import { GeneralTitleStyled } from '../../../globalStyles';

export const TitleStyled = styled(GeneralTitleStyled)`
  margin-bottom: 1rem;
`;

export const MessageStyled = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: 0.028rem;
  text-align: center;
  color: ${colors.neutral[900]};
  margin: 2rem 0 0;
`;

export const LoginButtonStyled = styled(Button)`
  width: 100%;
  margin: 5rem auto 3rem;
`;
